<div class="flex-center-between">
  <!-- El detalle se pinta SIEMPRE que llegue, no solo en los avisos rojos: un
       exito parcial (naranja) tambien tiene un motivo que contar (CEC-668). -->
  <div class="gap-100" [ngClass]="msg ? 'flex' : 'flex-center'">
    <app-st-icon [style.color]="iconColor" *ngIf="icon" [bold]="true" [name]="icon"></app-st-icon>
    <div style="padding: 3.5px 0" class="flex flex-column gap-100">
      <span class="text-label-14 text-semibold">{{content}}</span>
      <span *ngIf="msg" class="text-label-12" style="color: white">{{msg}}</span>
    </div>
  </div>

  <div class="flex gap-050">
    <button *ngIf="showUndo" nz-button nzSize="large" nzType="text" nzShape="circle">
      <app-st-icon [bold]="true" name="undo"></app-st-icon>
    </button>
    <button nz-button nzSize="large" nzType="text" nzShape="circle" (click)="close()">
      <app-st-icon [bold]="true" name="close"></app-st-icon>
    </button>
  </div>
</div>
